class Bundle {
  constructor(language) {
    this.language = "en";
    this._messages = {};

    this.setLanguage(language);
  }

  setLanguage(language) {
    if (language in Bundle.plurals) {
      this.language = language;
    }
  }

  addMessages(messages) {
    this._messages = { ...this._messages, ...messages };
  }

  translate(key, tokens) {
    let message = this._messages[key];
    let warning = "Message '" + key + "' not found in bundle, or it cannot be formatted.";

    try {
      if (message instanceof Array) {
        if (isNaN(tokens._count)) {
          throw warning;
        }

        message = Bundle.plurals[this.language](message, tokens._count);
      }

      if (message) {
        message = Bundle.format(message, tokens);

        if (message.match(/\{\w+\}/)) {
          throw warning;
        }

        return message;
      }

      throw warning;
    }
    catch (e) {
      if (window.console) {
        console.warn(e);
      }

      return key;
    }
  }
}

Bundle.format = function (message, tokens) {
  return message.replace(/\{(\w+)\}/g, function (match, p1) {
    let token = (tokens || {})[p1];
    return token === undefined ? match : token;
  });
};

// http://bit.ly/1t9zfpu
Bundle.plurals = {
  en: function (msgs, n) {
    return msgs[n === 1 ? 0 : 1];
  },
  es: function (msgs, n) {
    return msgs[n === 1 ? 0 : 1];
  },
  ja: function (msgs, n) {
    return msgs[0];
  }
};

module.exports = Bundle;